import styled from '@emotion/styled'
import DropDown from 'src/assets/images/nav/dropdown-icon.svg'
import { NavItem } from 'src/components/parts/navigation/MainNav'

interface Props {
    to: string
    $expanded?: boolean
    $active?: boolean
    $small?: boolean
    children: React.ReactNode
    expandTestId: string
    isExpanded: boolean
    onExpandToggle: () => void
    showExpandButton?: boolean
    onClick?: () => void
    dataTestId?: string
}

export const ExpandableNavItem = ({
    to,
    $expanded,
    $active,
    $small,
    children,
    expandTestId,
    isExpanded,
    onExpandToggle,
    showExpandButton = true,
    onClick,
    dataTestId,
}: Props) => {
    const handleExpandClick = (e: React.MouseEvent) => {
        e.preventDefault()
        e.stopPropagation()
        onExpandToggle()
    }

    return (
        <NavItemContainer>
            <NavItem
                to={to}
                $expanded={$expanded}
                $active={$active}
                $small={$small}
                onClick={onClick}
                data-testid={dataTestId}
                $hasExpandButton={showExpandButton}
            >
                {children}
            </NavItem>
            {showExpandButton && (
                <ExpandButton data-testid={expandTestId} onClick={handleExpandClick} $isExpanded={isExpanded}>
                    <img src={DropDown} alt='' />
                </ExpandButton>
            )}
        </NavItemContainer>
    )
}

const NavItemContainer = styled.div`
    display: flex;
    align-items: center;
    position: relative;
`

const ExpandButton = styled.button<{ $isExpanded: boolean }>`
    background: none;
    border: none;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.5;
    transition: opacity 0.2s ease-in-out;

    &:hover {
        opacity: 1;
    }

    img {
        transform: ${props => (props.$isExpanded ? '' : 'rotate(180deg)')};
        transition: transform 0.2s ease-in-out;
    }
`

export const Row = styled.div`
    display: flex;
`
